"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Panel.css");
var Panel = (function (_super) {
    __extends(Panel, _super);
    function Panel(props) {
        return _super.call(this, props) || this;
    }
    ;
    Panel.prototype.render = function () {
        var _a = this.props, backgroundColor = _a.backgroundColor, customBackgroundColor = _a.customBackgroundColor, backgroundImage = _a.backgroundImage, backgroundPosition = _a.backgroundPosition, backgroundStyle = _a.backgroundStyle, borderColorAll = _a.borderColorAll, borderColorBottom = _a.borderColorBottom, borderColorLeft = _a.borderColorLeft, borderColorRight = _a.borderColorRight, borderColorTop = _a.borderColorTop, borderStyleAll = _a.borderStyleAll, borderStyleBottom = _a.borderStyleBottom, borderStyleHorizontal = _a.borderStyleHorizontal, borderStyleLeft = _a.borderStyleLeft, borderStyleRight = _a.borderStyleRight, borderStyleTop = _a.borderStyleTop, borderStyleVertical = _a.borderStyleVertical, borderWidthAll = _a.borderWidthAll, borderWidthBottom = _a.borderWidthBottom, borderWidthHorizontal = _a.borderWidthHorizontal, borderWidthLeft = _a.borderWidthLeft, borderWidthRight = _a.borderWidthRight, borderWidthTop = _a.borderWidthTop, borderWidthVertical = _a.borderWidthVertical, children = _a.children, height = _a.height, minHeight = _a.minHeight, minWidth = _a.minWidth, width = _a.width, maxHeight = _a.maxHeight, maxWidth = _a.maxWidth, horizontalAlign = _a.horizontalAlign, overflowX = _a.overflowX, overflowY = _a.overflowY, paddingAll = _a.paddingAll, paddingBottom = _a.paddingBottom, paddingHorizontal = _a.paddingHorizontal, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, paddingTop = _a.paddingTop, paddingVertical = _a.paddingVertical, roundedCorner = _a.roundedCorner, verticalAlign = _a.verticalAlign, tag = _a.tag;
        var cssClasses = ['p-panel'];
        var inlineStyles;
        var isValignAndHeightSet;
        function customizeEnums(en) {
            var cases = {
                'Zero': 'none',
                'Xsmall': 'xs',
                'Small': 'sm',
                'Medium': 'md',
                'Large': 'lg',
                'Xlarge': 'xl',
                'Xlarge2': '2x',
                'Xlarge3': '3x',
                'Xlarge4': '4x',
                'Xlarge5': '5x',
                "Primary": "primary50",
                "Secondary": "secondary50",
                "Success": "success50",
                "Warning": "warning50",
                "Error": "error50",
                "Info": "info50"
            };
            return cases[en]
                ? cases[en]
                : en.toLowerCase().replace(' ', '-');
        }
        ;
        function constructClass(prop, prefix, ignore) {
            if (ignore === void 0) { ignore = 'None'; }
            if (prop && prop !== ignore) {
                var customProp = customizeEnums(prop);
                cssClasses.push(prefix + "-" + customProp);
            }
            ;
        }
        ;
        if (!customBackgroundColor) {
            constructClass(backgroundColor, 'p-bg');
        }
        constructClass(paddingAll, 'p-p');
        constructClass(paddingHorizontal, 'p-p-h');
        constructClass(paddingVertical, 'p-p-v');
        constructClass(paddingTop, 'p-p-t');
        constructClass(paddingRight, 'p-p-r');
        constructClass(paddingBottom, 'p-p-b');
        constructClass(paddingLeft, 'p-p-l');
        constructClass(borderWidthAll, 'p-bw');
        constructClass(borderWidthHorizontal, 'p-bw-h');
        constructClass(borderWidthVertical, 'p-bw-v');
        constructClass(borderWidthTop, 'p-bw-t');
        constructClass(borderWidthRight, 'p-bw-r');
        constructClass(borderWidthBottom, 'p-bw-b');
        constructClass(borderWidthLeft, 'p-bw-l');
        constructClass(borderColorAll, 'p-bc');
        constructClass(borderColorTop, 'p-bc-t');
        constructClass(borderColorRight, 'p-bc-r');
        constructClass(borderColorBottom, 'p-bc-b');
        constructClass(borderColorLeft, 'p-bc-l');
        constructClass(borderStyleAll, 'p-bs');
        constructClass(borderStyleHorizontal, 'p-bs-h');
        constructClass(borderStyleVertical, 'p-bs-v');
        constructClass(borderStyleTop, 'p-bs-t');
        constructClass(borderStyleRight, 'p-bs-r');
        constructClass(borderStyleBottom, 'p-bs-b');
        constructClass(borderStyleLeft, 'p-bs-l');
        constructClass(roundedCorner, 'rounded');
        constructClass(horizontalAlign, 'halign');
        constructClass(verticalAlign, 'valign', 'Top');
        if (backgroundImage || minHeight || height || minWidth || maxHeight || width || maxWidth || customBackgroundColor) {
            inlineStyles = {};
            if (backgroundImage) {
                constructClass(backgroundPosition, 'position');
                constructClass(backgroundStyle, 'style', null);
                inlineStyles['backgroundImage'] = "url(" + backgroundImage + ")";
            }
            ;
            if (customBackgroundColor) {
                inlineStyles['backgroundColor'] = customBackgroundColor;
            }
            ;
            if (minHeight || height) {
                isValignAndHeightSet = verticalAlign !== 'Top';
            }
            ;
            if (minHeight) {
                inlineStyles['minHeight'] = minHeight;
            }
            ;
            if (height) {
                inlineStyles['height'] = height;
            }
            ;
            if (overflowY) {
                inlineStyles['overflowY'] = overflowY.toLowerCase();
            }
            if (overflowX) {
                inlineStyles['overflowX'] = overflowX.toLowerCase();
            }
            if (minWidth) {
                inlineStyles['minWidth'] = minWidth;
            }
            if (width) {
                inlineStyles['width'] = width;
            }
            if (maxWidth) {
                inlineStyles['maxWidth'] = maxWidth;
            }
            if (maxHeight) {
                inlineStyles['maxHeight'] = maxHeight;
            }
        }
        ;
        return (React.createElement("div", { className: cssClasses.join(' '), style: inlineStyles, "data-tag": tag }, isValignAndHeightSet ? React.createElement("div", null,
            React.createElement("div", null, children))
            : React.createElement("div", null, children)));
    };
    ;
    return Panel;
}(React.Component));
Panel.defaultProps = {
    backgroundColor: 'None',
    customBackgroundColor: '',
    backgroundImage: '',
    backgroundPosition: 'Left Top',
    backgroundStyle: 'None',
    height: '',
    minHeight: '',
    maxHeight: '',
    minWidth: '',
    width: '',
    maxWidth: '',
    overflowX: 'Hidden',
    overflowY: 'Hidden',
    paddingAll: 'None',
    paddingHorizontal: 'None',
    paddingVertical: 'None',
    paddingTop: 'None',
    paddingRight: 'None',
    paddingBottom: 'None',
    paddingLeft: 'None',
    borderWidthAll: 'None',
    borderWidthHorizontal: 'None',
    borderWidthVertical: 'None',
    borderWidthTop: 'None',
    borderWidthRight: 'None',
    borderWidthBottom: 'None',
    borderWidthLeft: 'None',
    borderColorAll: 'None',
    borderColorTop: 'None',
    borderColorRight: 'None',
    borderColorBottom: 'None',
    borderColorLeft: 'None',
    borderStyleAll: 'None',
    borderStyleHorizontal: 'None',
    borderStyleVertical: 'None',
    borderStyleTop: 'None',
    borderStyleRight: 'None',
    borderStyleBottom: 'None',
    borderStyleLeft: 'None',
    roundedCorner: 'None',
    verticalAlign: 'Top',
    horizontalAlign: 'None',
    children: [],
    tag: null
};
exports.Panel = Panel;
;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['layout-controls'])
        csod.engine.controls['layout-controls'] = {};
    csod.engine.controls['layout-controls']['Panel'] = Panel;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Panel"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-layout-controls/controls/Panel/index.js
// module id = 8
// module chunks = 0 1 2